import { countryData } from '@/constants/country-data'

const getCenterLocationByCountryCode = (countryCode) => {
  const country = countryData.find((c) => c.countryCode === countryCode)

  return country ? country.location : {}
}

const getAllSupportedCountryCodes = () => {
  return countryData.map((c) => c.countryCode)
}

/**
 * Get user's country code using IP-based geolocation
 * @returns {Promise<string>} Promise that resolves to country code (e.g., 'SA', 'AE')
 */
const getUserCountryCode = async () => {
  try {
    // Use ipapi.co - a reliable and free IP geolocation service
    const response = await fetch('https://ipapi.co/json/', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      // Add timeout to prevent hanging requests
      signal: AbortSignal.timeout(5000),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    const countryCode = data.country_code

    if (!countryCode) {
      throw new Error('No country code received from IP service')
    }

    // Check if the detected country is in our supported countries
    const supportedCountry = countryData.find(
      (country) => country.countryCode === countryCode
    )

    if (supportedCountry) {
      console.log(`Detected country: ${countryCode}`)
      return countryCode
    } else {
      // Default to SA if country is not supported
      console.warn(
        `Detected country ${countryCode} is not supported, defaulting to SA`
      )
      return 'SA'
    }
  } catch (error) {
    console.warn('Failed to detect country from IP, defaulting to SA:', error)
    return 'SA'
  }
}

export {
  getCenterLocationByCountryCode,
  getAllSupportedCountryCodes,
  getUserCountryCode,
}
